import { differenceInYears, parse } from 'date-fns';
import { BaselineAlert, VsAlert } from 'src/types/alerts';
import dayjs from 'dayjs';
import { PatientAlertsByType } from 'src/redux/data/alerts/modules/types';
import { DeviceAlerts } from 'src/routes/NursesStation/modules/types';

export const calculatePatientAge = (
  dateOfBirth: string | undefined,
): string => {
  if (!dateOfBirth) {
    return '-';
  }

  const date = parse(dateOfBirth, 'yyyy-MM-dd', new Date());
  const age = differenceInYears(new Date(), date);

  return age.toString();
};

const getLatestAlert = (
  a1: VsAlert | BaselineAlert | undefined,
  a2: VsAlert | BaselineAlert | undefined,
): VsAlert | BaselineAlert | undefined => {
  if (!a1) {
    return a2;
  }

  if (!a2) {
    return a1;
  }

  return dayjs(a1.startTime).isAfter(a2.startTime) ? a1 : a2;
};

export const selectDeviceAlerts = ({
  HR,
  RR,
  HR_BASELINE,
  RR_BASELINE,
  BED_EXIT,
  LONG_OUT_OF_BED,
  BED_EXIT_FREQUENCY,
}: PatientAlertsByType): DeviceAlerts => ({
  latestHrAlert: getLatestAlert(HR, HR_BASELINE),
  latestRrAlert: getLatestAlert(RR, RR_BASELINE),
  occupancyAlert: BED_EXIT,
  longOutOfBed: LONG_OUT_OF_BED,
  bedExitFrequency: BED_EXIT_FREQUENCY,
});
